import moment from 'moment-timezone'
import { getIsLate, getLateDuration } from 'utils/trackingHelpers'
import TIME_CONSTANTS from 'constants/datetime'

export default class ManualEta {
  constructor(manualEta, scheduledArrival, timezone) {
    this._manualEta = moment.tz(manualEta, timezone)
    this._scheduledArrival = moment.tz(scheduledArrival, timezone)
  }

  get formatted() {
    return this._manualEta.format()
  }

  get dateTime() {
    return this._manualEta.format(TIME_CONSTANTS.etaFormat)
  }

  get date() {
    return this._manualEta.format(TIME_CONSTANTS.dateFormat)
  }

  get time() {
    return this._manualEta.format(TIME_CONSTANTS.timeFormat)
  }

  get isLate() {
    return getIsLate(this._manualEta, this._scheduledArrival)
  }

  get lateDuration() {
    return this.isLate ? getLateDuration(this._manualEta, this._scheduledArrival) : ''
  }
}
